import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

import Container from '@/legacy-src/rebrand/Container'
import { getTranslate } from '@/legacy-src/utilities/i18n'
import isCountry from '@/legacy-src/utilities/isCountry'

import type { CMSMenuItem } from '@/src/domains/cms-menus/schemas'
import { getCMSMenuItemHref } from '@/src/domains/cms-menus/utils/getCMSMenuItemHref'

import ContactInfo from './ContactInfo'
import FooterColumn from './FooterColumn'
import FooterInformation from './FooterInformation'
import PaymentOptionsFooter from './PaymentOptionsFooter'

const Footer: React.FC<{ menu?: CMSMenuItem[]; isBusinessPage?: boolean }> = ({ menu, isBusinessPage }) => {
  const { t } = getTranslate()
  return (
    <div className="relative text-white">
      <div className={`flex justify-center bg-secondary pt-4`}>
        <Container className="z-20 mx-8 pb-8 pt-10 big-tablet:flex">
          <div className="text-center big-tablet:w-1/3 big-tablet:pr-10 big-tablet:!text-left laptop:pr-16">
            <ContactInfo isBusinessPage={isBusinessPage} />
          </div>
          <div className="big-tablet:w-2/3">
            <div className="mb-10 justify-between tablet:mx-10 tablet:flex big-tablet:ml-0 big-tablet:mr-20">
              {menu ? (
                <>
                  {menu.map((topLevel) => (
                    <div className="pr-8 last:pr-0" key={topLevel.id}>
                      <h2 className={`mb-8 text-xl font-bold text-pink-500`}>{topLevel.title}</h2>
                      <div className="text-sm">
                        {topLevel.children?.map((item) => (
                          <Link
                            key={item.id}
                            href={getCMSMenuItemHref(item)}
                            className="mb-6 block text-white underline hover:!text-peach-400"
                          >
                            {item.title}
                          </Link>
                        ))}
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  <FooterColumn name="about" className="pr-8" />
                  <FooterColumn name="information" className="pr-8" />
                  <FooterColumn name="forPartners" />
                </>
              )}
            </div>
            <hr className="mb-10 border-2 border-petrol-400" />
            <FooterInformation />
            <div className="flex flex-wrap items-center">
              <PaymentOptionsFooter />
              {isCountry('ro') && (
                <div>
                  <Link href={t('component.footer.ro.sal')} rel="noopener noreferrer" target="_blank">
                    <Image
                      src="/images/sal-ro.png"
                      alt="sal"
                      width={509}
                      height={126}
                      className="mb-4 mr-5 h-12 w-auto"
                    />
                  </Link>
                  <Link href={t('component.footer.ro.sol')} rel="noopener noreferrer" target="_blank">
                    <Image src="/images/sol.png" alt="sol" width={509} height={126} className="mb-4 h-12 w-auto" />
                  </Link>
                </div>
              )}
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default Footer
